import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Table, TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import {
  DialogService,
  DynamicDialogComponent,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import {
  ProductInterface,
  ProviderProductInterface,
} from '../../../core/interfaces/product/product';
import { ProviderCategoryAttributesService } from '../../../core/services/categories/provider-category-attributes.service';
import { RedisProviderCategoryAttributeRootInterface } from '../../../core/interfaces/categories/provider-category-attributes-interface';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UniqVariantList } from '../../../core/interfaces/variants/variants-interface';
import { TuiFilterPipeModule } from '@taiga-ui/cdk';
import { Value } from '../../../core/classes/product/product';
import { ChipModule } from 'primeng/chip';
import { Subject, takeUntil } from 'rxjs';
import { Select } from 'primeng/select';
import { InputGroupAddon } from 'primeng/inputgroupaddon';
import { InputGroup } from 'primeng/inputgroup';

@Component({
    selector: 'magenty-variants-matching',
    imports: [
        CommonModule,
        TableModule,
        InputTextModule,
        ButtonModule,
        ReactiveFormsModule,
        FormsModule,
        TuiFilterPipeModule,
        ChipModule,
        Select,
        InputGroupAddon,
        InputGroup,
    ],
    templateUrl: './variants-matching.component.html',
    styleUrl: './variants-matching.component.scss'
})
export class VariantsMatchingComponent implements OnInit, OnDestroy {
  instance: DynamicDialogComponent | undefined;
  product: ProductInterface | undefined;
  providerProduct: ProviderProductInterface | undefined;
  private destroy$ = new Subject<void>();
  providerProductVariantItems: UniqVariantList[] = [];
  providerCategoryAttributes: RedisProviderCategoryAttributeRootInterface[] =
    [];
  readonly matcher = (details: Value, search: string): boolean =>
    details.Key === search;

  constructor(
    private providerCategoryAttributesService: ProviderCategoryAttributesService,
    public ref: DynamicDialogRef,
    private dialogService: DialogService
  ) {
    this.instance = this.dialogService.getInstance(this.ref);
    if (this.instance && this.instance.data) {
      this.product = this.instance.data.product;
      this.providerProduct = this.instance.data.providerProduct;
      const request = {
        ProviderId: this.providerProduct!.ProviderId,
        CategoryCode: this.providerProduct!.Category,
        MarketplaceIdentity: this.providerProduct!.MarketplaceIdentity,
      };

      this.providerCategoryAttributesService
        .getList(request)
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
          this.providerCategoryAttributes = res;
          this.providerProductVariantItemsFill();
        });
    }
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  featureMatch = () => {
    this.providerProductVariantItems.map((variantItem) => {
      if (!variantItem.NameMatchin) {
        const found = this.providerCategoryAttributes.find(
          (f) => f.lowercaseName === variantItem.VariantKey.toLowerCase()
        );
        if (found) {
          variantItem.Name = found.Name;
          variantItem.lowercaseName = found.lowercaseName;
          variantItem.NameId = found.Code;
          variantItem.NameMatchin = true;
          variantItem.Values = found.Values;
        }
      }
      if (!variantItem.ValueMatchin) {
        if (variantItem.Values.length > 0) {
          const found = variantItem.Values.find(
            (f) =>
              f.lowercaseValue === variantItem.VariantValue.toLocaleLowerCase()
          );
          if (found) {
            variantItem.ValueMatchin = true;
            variantItem.Value = found.Value;
            variantItem.lowercaseValue = found.lowercaseValue;
            variantItem.ValueId = found.Key;
          }
        } else {
          variantItem.ValueMatchin = true;
          variantItem.Value = variantItem.VariantValue;
          variantItem.ValueId = variantItem.VariantValue;
          variantItem.lowercaseValue =
            variantItem.VariantValue.toLocaleLowerCase();
        }
      }
    });
  };

  clearMatch = () => {
    this.providerProductVariantItems.map((variantItem) => {
      variantItem.Name = '';
      variantItem.NameId = '';
      variantItem.lowercaseName = '';
      variantItem.Value = '';
      variantItem.ValueId = '';
      variantItem.lowercaseValue = '';
      variantItem.Values = [];
      variantItem.ValueMatchin = false;
      variantItem.NameMatchin = false;
    });
  };

  providerProductVariantItemsFill = () => {
    this.providerProductVariantItems = [
      ...this.providerProduct!.getUniqVariantList(),
    ];
    this.providerProductVariantItems.map((f) => {
      this.changeName(f.lowercaseName, f);
    });
  };

  changeName = (event: string, variantItem: UniqVariantList) => {
    const found = this.providerCategoryAttributes.find(
      (f) => f?.lowercaseName === event
    );
    if (found) {
      variantItem.Name = found.Name;
      variantItem.lowercaseName = found.Name.toLowerCase();
      variantItem.NameId = found.Code;
      variantItem.Values = found.Values;
      variantItem.NameMatchin = true;
      variantItem.ValueMatchin = false;
      variantItem.Value = '';
      variantItem.ValueId = '';
      variantItem.lowercaseValue = '';
    }
  };

  changeValue = (event: string, variantItem: UniqVariantList) => {
    if (variantItem) {
      if (variantItem.Values.length > 0) {
        const found = variantItem.Values.find(
          (f) => f.lowercaseValue === event
        );
        if (found) {
          variantItem.ValueId = found.Key;
          variantItem.Value = found.Value;
          variantItem.lowercaseValue = event;
        }
      } else {
        variantItem.ValueId = event;
        variantItem.Value = event;
        variantItem.lowercaseValue = event.toLocaleLowerCase();
      }
      variantItem.ValueMatchin = event.length > 0;
    }
  };

  clear(table: Table) {
    table.clear();
  }
}
